<template>
  <span>
    <outdated-info
      :real="durationString"
      :planned="plannedDurationString"
      :inline="inline"
    ></outdated-info>
  </span>
</template>

<script setup lang="ts">
import OutdatedInfo from './OutdatedInfo.vue'
import type { Duration } from 'dayjs/plugin/duration'
import { computed } from 'vue'

const {
  duration,
  plannedDuration,
  inline = false
} = defineProps<{
  duration: Duration
  plannedDuration?: Duration
  inline?: boolean
}>()

const durationString = computed(() => {
  let formatters = []
  if (duration.days() != 0) formatters.push('D[ Tag],')
  if (duration.hours() != 0) formatters.push('H[h]')
  if (duration.minutes() != 0) formatters.push('m[min]')
  if (formatters.length == 0) formatters.push('m[min]')
  return duration.format(formatters.join(' '))
})

const plannedDurationString = computed(() => {
  if (plannedDuration) {
    let formatters = []
    if (plannedDuration.days() != 0) formatters.push('D[ Tag],')
    if (plannedDuration.hours() != 0) formatters.push('H[h]')
    if (plannedDuration.minutes() != 0) formatters.push('m[min]')
    if (formatters.length == 0) formatters.push('m[min]')
    return plannedDuration.format(formatters.join(' '))
  } else {
    return ''
  }
})
</script>
